import React from 'react'
import { THUMBNAIL_HEIGHT, THUMBNAIL_WIDTH } from '../constants';
import ImageLoader from './ImageLoader'

const ImageUploadInput = ({ layer, asset, onChange, index }) => (
  <div className="mb-3">
    <ImageLoader
      key={layer.nm}
      label={layer.nm}
      url={asset.p}
      id={layer.nm}
      onChange={onChange}
      imageWidth={asset.w >= asset.h
        ? THUMBNAIL_WIDTH
        : (THUMBNAIL_HEIGHT * asset.w / asset.h) >> 0}
      imageHeight={asset.h >= asset.w
        ? THUMBNAIL_HEIGHT
        : (THUMBNAIL_WIDTH * asset.h / asset.w) >> 0}
    />
  </div>
)

export default ImageUploadInput;



// WEBPACK FOOTER //
// ./src/components/ImageUploadInput.js